/**
 *
 */
export class OrderNumQuota {

  /** . */
  OrderNumQuotaCode = '';

  /** . */
  OrderNumQuotaName = '';

  /** . */
  DelivCatalogID = '';

  /** . */
  DeliveryWeekFixFlag = '';

  /** . */
  OrderNumQuotaCodeName = '';
}
